import { useHistory } from "react-router-dom";
import "./styles.css";

// eslint-disable-next-line react/prop-types
function ProfileCard({ id, profile, imgSrc }) {
  const history = useHistory();

  const handleLearnMoreClick = () => {
    history.push(`/learnmore/${id}`, { scrollY: window.scrollY });
  };

  return (
    <div className="profile-card">
      <img src={imgSrc} height="120" alt="domain" id="profile-img" />
      <h2>{profile}</h2>
      <button className="learnMore-btn" onClick={handleLearnMoreClick}>
        Learn more
      </button>
    </div>
  );
}

export default ProfileCard;